import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getTicketsByCategoryId = async (params: any) => {
  const url = endpoints.TICKET;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const resetTicket = async (id: any) => {
  const url = endpoints.TICKET + "/" + id;

  const { data: response } = await axios.patch(url, {}, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const resendTicket = async (id: any) => {
  const url = endpoints.TICKET + "/resend";

  const { data: response } = await axios.post(url, { id: id }, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const services = {
  getTicketsByCategoryId,
  resetTicket,
  resendTicket
};

export default services;
